import { gsap } from 'gsap';
import imagesLoaded from 'imagesloaded';

// https://codepen.io/mitchellcliftonbarton/pen/mdwJMbo
// https://codepen.io/sgorneau/pen/OdGbow
// https://gsap.com/community/forums/topic/19874-change-direction-of-carousel-wrap-example/
window.addEventListener('load',()=>{

  const blocks = document.querySelectorAll('.image-sliders');
  imagesLoaded( blocks, function() {

    let sliders = document.querySelectorAll('.image-sliders__gallery');
    sliders.forEach((item, key) => {

      const inner = item.querySelector('.image-sliders__gallery-inner')
      const items = Array.from(inner.querySelectorAll('.image-sliders__gallery-item'))
      const reverseDirection = key % 2 == 0;

      let wrapWidth = 0
      // const viewWidth = item.clientWidth
      let widths = []

      // get total wrap width, and set items at initial positions
      items.forEach(item => {
        let width = item.clientWidth
        let widthBefore = wrapWidth
        widths.push(width)

        gsap.set(item, { x: widthBefore })

        wrapWidth += item.clientWidth
      })

      // get longest width of item widths and set inner position based off value
      const longestWidth = widths.reduce((a, b) => {
        return Math.max(a, b)
      }, 0)
      if(reverseDirection) {
        gsap.set(inner, { left: -longestWidth })
      }

      // setup animation
      gsap.to(items, {
        x: reverseDirection ? "+=" + wrapWidth : "-=" + wrapWidth,
        ease: 'none',
        paused: false,
        repeat: -1,
        duration: 60,
        modifiers: {
          x: (x) => {
            if(reverseDirection) {
              x = parseFloat(x) % wrapWidth
            } else {
              x = parseFloat(x) + longestWidth < 0 ? (parseFloat(x) % wrapWidth) + wrapWidth : parseFloat(x) % wrapWidth
            }

            return x + 'px'
          },
        },
      })
    });
  });
});
